import { useCallback, useContext } from 'react';
import moment from 'moment';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import { AjaxContext, formatListData, AppContext, EMPTY_ARRAY, UserContext } from 'commons-ui';
import { GAME_NAMES, GAME_NAME_OPTIONS } from 'pages/constants';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { UserDetailsContext } from 'context/userDetails';
import { ITournamentDetails } from '../types';

const GAMEPLAY_THRESHOLD_SECONDS: number = 480;
const getNxEndTime = (time: number) => {
	return moment(time).add(GAMEPLAY_THRESHOLD_SECONDS, 'seconds').valueOf();
};

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { app } = useContext(AppContext);
	const {
		selectedUser: { uid, ludoUserId }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);
	const getGameAndNetworkLogs = useCallback(async (props: ITournamentDetails) => {
		const { gameName, tableId, registeredOnInMS, tournamentStartTimeInMS, tournamentEndTimeInMS, gameUid, ltid, gameType } =
			props;
		const { appName } = app;
		const permission = _find(permissionsConfig, { actionName: ACTION.getGameplayTimeline });
		const result = await postData({
			endpoint: `/dashboard/getGameplayTimeline/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.gameplay}-getGameplayTimeline`,
			queryParams: {
				appName
			},
			body: {
				gameUid,
				ltid,
				zupeeUserId: uid,
				gameName,
				tableId,
				registeredOn: registeredOnInMS,
				startTime: gameName === GAME_NAME_OPTIONS[GAME_NAMES.LUDONX] ? registeredOnInMS : tournamentStartTimeInMS,
				endTime: gameName === GAME_NAME_OPTIONS[GAME_NAMES.LUDONX] ? getNxEndTime(registeredOnInMS) : tournamentEndTimeInMS,
				ludoUserId,
				...(_isNil(gameType) || _isEmpty(gameType) ? {} : { gameType })
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const data = _get(result, ['data', 'gameAndNetworkLog'], EMPTY_ARRAY);
		const listData = formatListData(data);

		return { rowCount: listData.length, data: listData };
	}, []);

	return { getGameAndNetworkLogs };
};

export default useService;
